import { useQueries } from '@tanstack/react-query';
import { contentListQueries } from 'src/modules/contentList/queries';
export function useAllPages(modules) {
    return useQueries({
        queries: modules?.map((module) => ({
            ...contentListQueries.getPages(module.id),
            // Return only previously fetched pages
            enabled: false
        })) ?? [],
        combine(result) {
            return result.flatMap((pages) => pages.data ?? []) ?? [];
        }
    });
}
